import React from "react";

export const Mint = () => {
  return <div>Mint</div>;
};
